import type { Namespace, TFunction } from 'i18next';

/**
 * Localized label for an app user role (Postgres `Role` enum string). Explicit
 * mapping — translation keys must never be constructed dynamically. Unknown or
 * missing roles render nothing.
 */
export function getRoleLabel(t: TFunction<Namespace>, role: string | undefined): string | undefined {
    switch (role) {
        case 'MANAGER':
            return t('user_table__role_manager', { ns: 'team' });
        case 'SUPER_MANAGER':
            return t('user_table__role_super_manager', { ns: 'team' });
        case 'CUSTOMER_SERVICE_REP':
            return t('user_table__role_customer_service_rep', { ns: 'team' });
        case 'INSIDE_SALES_REP':
            return t('user_table__role_inside_sales_rep', { ns: 'team' });
        case 'OUTSIDE_SALES_REP':
            return t('user_table__role_outside_sales_rep', { ns: 'team' });
        case 'OTHER':
            return t('user_table__role_other', { ns: 'team' });
        default:
            return undefined;
    }
}
